var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#paint0_linear_109_833)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 23C30.3431 23 29 24.3431 29 26V31C29 32.6569 30.3431 34 32 34C33.6569 34 35 32.6569 35 31V26C35 24.3431 33.6569 23 32 23ZM33 39.9451V41.5C33 42.0523 32.5523 42.5 32 42.5C31.4477 42.5 31 42.0523 31 41.5V39.9451C26.5 39.4476 23 35.6326 23 31C23 30.4477 23.4477 30 24 30C24.5523 30 25 30.4477 25 31C25 34.866 28.134 38 32 38C35.866 38 39 34.866 39 31C39 30.4477 39.4477 30 40 30C40.5523 30 41 30.4477 41 31C41 35.6326 37.5 39.4476 33 39.9451ZM32 21C34.7614 21 37 23.2386 37 26V31C37 33.7614 34.7614 36 32 36C29.2386 36 27 33.7614 27 31V26C27 23.2386 29.2386 21 32 21Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_833",
    x1: -12,
    y1: 20,
    x2: 64,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D45DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.7d5693f6f72032a1adb8e1fb43d6c437.svg";
export { ForwardRef as ReactComponent };